import React from 'react'
import HoverCard from "./containers/HoverCard";
import ItemContainer from './containers/ItemContainer';

export default function Faq({ question, answer }) {
    return (
        <HoverCard>
          <ItemContainer>
            <h5>{question}</h5>
            <p>{answer}</p>
          </ItemContainer>
        </HoverCard>
    );
}
